module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-base-shadow-8.6efee6a7.png";